import {logError} from 'root/log/log';

let injector, angularReadyListeners = []

export {
  onAngular,
  onAngularReady,
  injectorGet as AngularServices,
  $newScope,
  $state,
  PublishAngularInjectorForVue,
  accountRepository,
  currentUser,
  httpErrorHandler,
  mainAPI,
  authAPI,
  notificationUtils,
  ngDialog,
  hotelRfpBidManagerService,
  hotelDirectoryRepository,
  rfpManagerRepository,
  AccountRepository,
  InvitationService,
  InvitationHandlersRepository,
  RfpDestinationsViewService,
  RfpHotelBidRepository,
  authSession,
  PublicAuth,
  RfpHotelRfpRepository,
  BidManagerBidActionsService,
  BidManagerActionsFactory,
  BidManagerRedirectService,
  BidManagerService,
  BidManagerRepository,
  RfpHotelRfpDestinationsRepository,
  SignInService,
  $compile,
}

function onAngularReady(listener) {
  angularReadyListeners.push(listener);
}

function onAngular(){
  return new Promise(resolve => {
    const startTimeout = () => setTimeout(() => {
      if(injector) {
        resolve();
      } else {
        startTimeout();
      }
    }, 50);
    startTimeout();
  })
}

PublishAngularInjectorForVue.$inject = ['$injector']
function PublishAngularInjectorForVue($injector) {
  injector = $injector;
  angularReadyListeners.forEach(l => l());
  angularReadyListeners = [];
}

function injectorGet(name){
  if(!injector) {
    logError('Angular Injector not Loaded');
  }
  return injector.get(name)
}

function accountRepository(){
  return injectorGet('AccountRepository')
}

function currentUser(){
  return injectorGet('CurrentUser')
}

function mainAPI(){
  return injectorGet('MainAPI')
}

function authAPI(){
  return injectorGet('AuthAPI')
}

function httpErrorHandler(){
  return injectorGet('HttpErrorHandler')
}

function $newScope(){
  const $rootScope = injectorGet('$rootScope')
  return $rootScope.$new(true, $rootScope)
}

function $state(){
  return injectorGet('$state')
}

function notificationUtils(){
  return injectorGet('NotificationUtils')
}

function hotelDirectoryRepository(){
  return injectorGet('rbvHotelDirectoryRepository');
}
function ngDialog(){
  return injectorGet('rbDialog')
}

function hotelRfpBidManagerService(){
  return injectorGet('BidManagerService')
}

function rfpManagerRepository() {
  return injectorGet('rfpManagerRepository')
}

function AccountRepository() {
  return injectorGet('AccountRepository')
}

function InvitationService() {
  return injectorGet('InvitationService')
}

function InvitationHandlersRepository() {
  return injectorGet('InvitationHandlersRepository')
}

function RfpDestinationsViewService() {
  return injectorGet('RfpDestinationsViewService');
}

function RfpHotelBidRepository() {
  return injectorGet('RfpHotelBidRepository');
}

function RfpHotelRfpRepository() {
  return injectorGet('RfpHotelRfpRepository');
}

function authSession() {
  return injectorGet('AuthSession');
}

function PublicAuth() {
  return injectorGet('PublicAuth');
}

function BidManagerBidActionsService(){
  return injectorGet('BidManagerBidActionsService')
}

function BidManagerActionsFactory(){
  return injectorGet('BidManagerActionsFactory')
}

function BidManagerRedirectService(){
  return injectorGet('BidManagerRedirectService')
}

function BidManagerService(){
  return injectorGet('BidManagerService')
}

function BidManagerRepository(){
  return injectorGet('BidManagerRepository')
}

function RfpHotelRfpDestinationsRepository(){
  return injectorGet('RfpHotelRfpDestinationsRepository')
}

function SignInService() {
  return injectorGet('SignInService')
}

function $compile(){
  return injectorGet('$compile')
}
